import axios from 'axios'
import {InvoiceService} from "./InvoiceService";

export const createInvoiceService = (
    url: string,
): any => {
    return new InvoiceService(
        axios.create({
            baseURL: url,
            withCredentials: false,
        })
    )
}
